import styled from 'styled-components';

import { Tooltip, Box, OutlineCircleQuestionIcon } from '@frontend/components';

import { isMobileBrowser } from 'utils/browserUtils';

const ControlsInfoWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0.5rem 2rem;
`;

const ControlsHeader = styled.span`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const SpaceActionsHeader = styled.span`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 10px;
`;

const ControlsContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  width: 260px;
`;

const ControlsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
`;

const ControlTitle = styled.span`
  flex-basis: 50%;
  font-weight: 600;
  margin-right: 5px;
`;

const ControlValue = styled.span`
  flex-basis: 50%;
`;

const ControlsInfo = () => {
  const isMobile = isMobileBrowser();

  const controlsContent = (
    <ControlsInfoWrapper>
      <ControlsHeader>Partviewer Controls</ControlsHeader>
      <ControlsContent>
        <ControlsRow>
          <ControlTitle>Zoom:</ControlTitle>
          {isMobile ? (
            <ControlValue>Slide Fingers Apart</ControlValue>
          ) : (
            <ControlValue>Scroll</ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Rotate:</ControlTitle>
          {isMobile ? (
            <ControlValue>Drag Finger</ControlValue>
          ) : (
            <ControlValue>Drag LMB</ControlValue>
          )}
        </ControlsRow>
        {!isMobile && (
          <ControlsRow>
            <ControlTitle>Pan:</ControlTitle>
            <ControlValue>Drag RMB</ControlValue>
          </ControlsRow>
        )}
        <ControlsRow>
          <ControlTitle>Recenter Trackball:</ControlTitle>
          {isMobile ? (
            <ControlValue>Double Tap on Body</ControlValue>
          ) : (
            <ControlValue>Double Click on Body</ControlValue>
          )}
        </ControlsRow>
      </ControlsContent>
      <SpaceActionsHeader>3D-Space Actions</SpaceActionsHeader>
      <ControlsContent>
        <ControlsRow>
          <ControlTitle>Zoom To Fit:</ControlTitle>
          {isMobile ? (
            <ControlValue>Long Press on Body</ControlValue>
          ) : (
            <ControlValue>Right Click on Body</ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>View Normal To:</ControlTitle>
          {isMobile ? (
            <ControlValue>Long Press on Plane</ControlValue>
          ) : (
            <ControlValue>Right Click on Plane</ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Create Selection:</ControlTitle>
          {isMobile ? (
            <ControlValue>
              Long Press on Entity (when no selected entities)
            </ControlValue>
          ) : (
            <ControlValue>
              Right Click on Entity (when no selected entities)
            </ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Zoom to Selection:</ControlTitle>
          {isMobile ? (
            <ControlValue>
              Long Press Anywhere (when selected entities)
            </ControlValue>
          ) : (
            <ControlValue>
              Right Click Anywhere (when selected entities)
            </ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Clear Selection:</ControlTitle>
          {isMobile ? (
            <ControlValue>
              Long Press Anywhere (when selected entities)
            </ControlValue>
          ) : (
            <ControlValue>
              Right Click Anywhere (when selected entities)
            </ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Focus:</ControlTitle>
          {isMobile ? (
            <ControlValue>Long Press on Body</ControlValue>
          ) : (
            <ControlValue>Right Click on Body</ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Isolate Body:</ControlTitle>
          {isMobile ? (
            <ControlValue>Long Press on Body</ControlValue>
          ) : (
            <ControlValue>Right Click on Body</ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Hide Body:</ControlTitle>
          {isMobile ? (
            <ControlValue>Long Press on Body</ControlValue>
          ) : (
            <ControlValue>Right Click on Body</ControlValue>
          )}
        </ControlsRow>
        <ControlsRow>
          <ControlTitle>Show All Bodies:</ControlTitle>
          {isMobile ? (
            <ControlValue>Long Press Anywhere</ControlValue>
          ) : (
            <ControlValue>Right Click Anywhere</ControlValue>
          )}
        </ControlsRow>
      </ControlsContent>
    </ControlsInfoWrapper>
  );

  return (
    <Tooltip placement="bottom" label={controlsContent}>
      <Box borderRadius="full" color="feature.primary">
        <OutlineCircleQuestionIcon boxSize={3} />
      </Box>
    </Tooltip>
  );
};

export default ControlsInfo;
